export default class SearchResultFieldCtrl {
  constructor() {
    const vm = this;
    vm.$onInit = function () {};
  }
}
